import { AnswerResult } from "../../../../store/viewmodels/AnswerViewModel";
import { getDurationInSeconds } from "../../../utils/DateServices";

interface OrganizeResultItemProps {
    answer: AnswerResult,
}

function OrganizeResultItem(props: OrganizeResultItemProps): JSX.Element {

    let answerValue = props.answer.value;
    if (answerValue[answerValue.length - 1] === ";") {
        answerValue = answerValue.slice(0, answerValue.length - 1)
    }

    const answers: string[] = answerValue.split(";");

    let correctValue = props.answer.item.correct;
    if (correctValue[correctValue.length - 1] === ";") {
        correctValue = correctValue.slice(0, correctValue.length - 1)
    }

    let corrects = correctValue.split(";");

    const isCorrect = props.answer.value === props.answer.item.correct ? true : false;
    const correctColor = isCorrect ? "text-green-500" : "text-red-500";

    const answerElements = answers.map(a => <div className={correctColor + ""} key={"answer_" + a} >{a}</div>);
    const correctElements = corrects.map(c => <div className={""} key={"key_" + c}>{c}</div>);
    const start = new Date(Date.parse(props.answer.start_time));
    const end = new Date(Date.parse(props.answer.end_time));
    const answerDuration = getDurationInSeconds(end, start);

    let answerTime = <span className="text-center my-auto pb-1" key={"answerTime-" + props.answer.id}>{answerDuration + ' s'}</span>

    return (
        <div className="pb-1 mt-1 grid grid-cols-5 border-b border-teal-100">
            <div className="mx-0 px-0 col-span-2" key={"answerElements" + props.answer.id} >{answerElements}</div>
            <div className="ml-5 col-span-2" key={"correctElements" + props.answer.id}>{correctElements}</div>
            <div className="ml-10" key={"answerTimeDiv" + props.answer.id}>{answerTime}</div>
        </div>
    );
}

export default OrganizeResultItem;